"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const bytes_1 = require("./bytes");
function megaBytes(obj) {
    return bytes_1.bytes(obj) / bytes_1.bytes({ MB: 1 });
}
exports.megaBytes = megaBytes;
//# sourceMappingURL=mega-bytes.js.map